export  function getAuthUser(){

    var user=JSON.parse(localStorage.getItem("online_learning_site_user"));
    if (user)
    {
       return user;

    }
    else 
    {
        return false;
    }
       
   
}